export default __webpack_public_path__ + "static/media/Alarm.ce5324c4.mp3";